<template>
<div class="col-12 text-left">
    <app-nav-bar></app-nav-bar>
    <div class="main-content">
        <h3 class="p-2">
            <small class="text-muted">Unit of Measurement (UOM) Detail</small>
        </h3>
        <div class="p-2 dropdown-divider"></div>
        <div class="row">
            <div class="form-group col-3">
                <label>Code</label>
                <input type="text" class="form-control" v-model="uom.code" id="code" aria-describedby="action">
            </div>
            <div class="form-group col-3">
                <label>Name</label>
                <input type="text" class="form-control" v-model="uom.name" id="name" aria-describedby="action">
            </div>
        </div>
        <button type="button" class="btn btn-outline-success" @click="save">Save <i class="far fa-save"></i></button>
        <button type="button" class="btn btn-outline-danger" @click="cancel">Cancel <i class="far fa-window-close"></i></button>
        <br /><br />
    </div>
</div>
</template>

<script>
import api from '../../services/api'
import { UOM } from '../../models/uom'
import AppLookupField from '../../components/AppLookupField.vue'
import AppDatatable from '../../components/AppDatatable.vue'
import AppDatePicker from '../../components/AppDatePicker.vue'
import AppDropdown from '../../components/AppDropdown.vue'
import AppNavBar from '../../components/AppNavbar.vue'

export default {
    components: {
        AppLookupField, AppDatatable, AppDatePicker, AppDropdown, AppNavBar
    },
    data() {
        return {
            uom: {
                ...UOM
            }
        }
    },
    async created() {
        if(this.$route.query.id !== undefined) {
            const uomApi = api('UOM/detail')

            const uomResult = await uomApi.getWithParams(this.$route.query.id)
            this.uom = uomResult
        }
    },
    methods: {
        async save() {
            const uomApi = api('UOM')
            if(this.$route.query.id !== undefined) {
                await uomApi.update(this.uom, this.$route.query.id)
            } else {
                await uomApi.create(this.uom)
            }
            this.$router.push({ name: 'uom' })
        },
        cancel() {
            this.$router.push({ name: 'uom' })
        },
        finishLookup(data) {
            const currentUOM = this.uom
            this.uom = {
                ...currentUom,
                ...data
            }
        },
        selectChange(data) {
            const currentData = this.uom
            this.uom = {
                ...currentData,
                ...data
            }
        },
    }
}
</script>